import { Link } from "@tanstack/react-router";
import { Sparkles, ArrowRight } from "lucide-react";

/**
 * CTA secundário discreto que aparece em todas as ferramentas,
 * apontando para a IA Especialista em MEI. Não é banner nem popup.
 */
export function ToolCtaIA({ currentSlug }: { currentSlug?: string }) {
  // Não mostrar na própria página da IA.
  if (currentSlug === "ia-cnae-mei-2026") return null;

  return (
    <aside
      aria-label="IA Especialista em MEI"
      className="mt-8 rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/5 via-card to-card p-5 md:p-6 flex items-start gap-4 shadow-soft"
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Sparkles className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="font-display text-base md:text-lg font-bold leading-tight">
          Conheça também a IA Especialista em MEI
        </h3>
        <p className="mt-1 text-sm text-muted-foreground">
          Tire dúvidas em linguagem natural sobre DAS, INSS, CNAE, limite de faturamento e
          regularização — respostas instantâneas e gratuitas.
        </p>
        <Link
          to="/ferramentas/$slug"
          params={{ slug: "ia-cnae-mei-2026" }}
          className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline"
        >
          Conversar com a IA agora <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </aside>
  );
}
